/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const MapPinSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M16 6.054c0 1.89-1.275 3.477-3 3.927v9.25c0 .724-.52 2.769-1 2.769s-1-2.061-1-2.769v-9.25c-1.725-.45-3-2.037-3-3.927C8 3.815 9.79 2 12 2s4 1.815 4 4.054Zm-5.11-.992c.541-.603.719-1.332.397-1.63-.322-.296-1.021-.047-1.563.556-.541.603-.72 1.332-.397 1.629.321.296 1.021.048 1.563-.555Z" /></svg>);
const MapPinSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={MapPinSolidBase} {...rest} ref={ref} />);
export default MapPinSolid;